import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../../reducers';
import ResourcePanel from '../ResourcePanel';
import { FilledPositionConfig } from '../../Spread/Background';
import MediaPreview from '../../../../containers/Editor/EditPanel/SpreadBackgroundPanel/MediaPreview';
import { Api } from '../../../../typings/api';
import { EditableType } from '../../../../containers/Editor/constants';
import { setSpreadBackground } from '../../../../containers/Editor/actions';
import { BackgroundMediaData, BackgroundMediaType } from '../../../../containers/Editor/reducer';
import DriveItemUtils from '../../../../utils/driveItem';

interface SpreadBackgroundPanelProps {
	type: EditableType;
	spread: number[];
	currentBgMediaData: BackgroundMediaData | undefined;
	hasCustomBgMediaData: boolean;
	isGeneralBgData: boolean;
	importManagerId: string;
	isImporting: boolean;
	position: FilledPositionConfig;
	onPositionChange: (value: FilledPositionConfig) => void;
	dispatch: Dispatch<StoreState>;
}

interface ConfigItem {
	isValidResourceFromApp: (item: Api.DriveItem) => boolean;
	fileExtensions: string[];
}

const config: { [k: string]: ConfigItem } = {
	[EditableType.image]: {
		isValidResourceFromApp: ({ type }) => type === Api.DriveItemType.Image,
		fileExtensions: DriveItemUtils.imageWithPdfExtensions,
	},
	[EditableType.video]: {
		isValidResourceFromApp: ({ type }) => type === Api.DriveItemType.Movie,
		fileExtensions: DriveItemUtils.videoExtensions,
	},
};

const SpreadBackgroundPanel = ({
	type,
	spread,
	currentBgMediaData,
	hasCustomBgMediaData,
	importManagerId,
	isImporting,
	isGeneralBgData,
	position,
	onPositionChange,
	dispatch,
}: SpreadBackgroundPanelProps) => {
	const { isValidResourceFromApp, fileExtensions } = config[type];

	const handleResourceSelect = (driveItem: Api.DriveItem): void => {
		const { id, label, src, type } = driveItem;
		const mediaType = type === Api.DriveItemType.Image
			? BackgroundMediaType.IMAGE
			: BackgroundMediaType.MOVIE;

		dispatch(setSpreadBackground(spread, {
			globalId: id,
			label,
			relUrl: src,
			type: mediaType,
		}, isGeneralBgData));
	};

	const handleResourceReset = (): void => {
		dispatch(setSpreadBackground(spread, null, isGeneralBgData));
	};

	const mediaType = currentBgMediaData ? currentBgMediaData.type : BackgroundMediaType.IMAGE;
	const label = currentBgMediaData && 'label' in currentBgMediaData ? currentBgMediaData.label : '';

	const iconName = mediaType === BackgroundMediaType.IMAGE
		? 'iconset_uprez_image'
		: 'iconset_uprez_video';
	const hasMediaPreview = currentBgMediaData &&
		currentBgMediaData.type !== BackgroundMediaType.SLIDER &&
		!isImporting;

	return (
		<>
			{hasMediaPreview &&
				<>
					<MediaPreview
						bgMediaData={currentBgMediaData}
						spread={spread}
						isGeneralBgData={isGeneralBgData}
						position={position}
						onPositionChange={onPositionChange}
					/>
				</>
			}
			<ResourcePanel
				iconName={iconName}
				label={label}
				importManagerId={importManagerId}
				isImporting={isImporting}
				isValidResourceFromApp={isValidResourceFromApp}
				isOptimizedImageImport={type === EditableType.image}
				fileExtensions={fileExtensions}
				isFileExtensionsDisplayed={true}
				isResetButtonDisplayed={hasCustomBgMediaData}
				dispatch={dispatch}
				onResourceSelect={handleResourceSelect}
				onResourceReset={handleResourceReset}
			/>
		</>
	);
};

export default SpreadBackgroundPanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SpreadBackgroundPanel/index.tsx